/** Converts an ISO 3166-1 alpha-2 code (e.g. "LK") into its flag emoji using
 * Unicode regional indicator symbols — no icon library/asset needed. */
export const isoToFlagEmoji = (iso2: string): string =>
  iso2
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
